import {
  listenAuth,
  registerWithEmail,
  signInWithEmail,
  signInWithGoogle,
  sendPasswordResetEmail,
  logout,
  needsEmailVerification
} from "../../services/firebase";
import { syncPushNotificationsForUser } from "../../services/push";

export default {
  namespaced: true,
  state: () => ({
    user: null,
    inited: false
  }),
  getters: {
    isAuthed: s => !!s.user,
    user: s => s.user,
    uid: s => s.user?.uid || null,
    inited: s => s.inited
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setInited(state, v) {
      state.inited = v;
    }
  },
  actions: {
    initAuth({ commit, state }) {
      if (state.inited) return;
      return new Promise(resolve => {
        const unsub = listenAuth(async user => {
          if (needsEmailVerification(user)) {
            user = null;
          }

          commit("setUser", user || null);
          try {
            await syncPushNotificationsForUser(user || null);
          } catch (e) {
            console.error("Push init error:", e);
          }
          commit("setInited", true);
          resolve();
          // keep listening (do not unsub)
        });
        // keep unsub in closure if you want later
        void unsub;
      });
    },
    async loginGoogle(_, payload = {}) {
      await signInWithGoogle(payload);
    },
    async loginEmail(_, payload) {
      await signInWithEmail(payload);
    },
    async registerEmail(_, payload) {
      await registerWithEmail(payload);
    },
    async resetPassword(_, email) {
      await sendPasswordResetEmail(email);
    },
    async logout() {
      await logout();
    }
  }
};
